export const DEFAULT_PANEL_WIDTH = 400;
